/**
 * Framer-Style Scroll Animations Suite (GSAP + ScrollTrigger)
 * 
 * Automatically applies smooth scroll-driven entries, word reveals,
 * parallax image scrolling, and staggered card entries.
 */

document.addEventListener('DOMContentLoaded', () => {
  const gsap = window.gsap;
  if (!gsap || !window.ScrollTrigger) {
    console.warn('GSAP or ScrollTrigger not loaded. Animations skipped.');
    return;
  }

  // Register ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Run animations
  initScrollAnimations();

  // Re-run animations when sections are loaded in the Shopify Theme Editor
  document.addEventListener('shopify:section:load', () => {
    // Refresh ScrollTrigger to calculate new offsets
    ScrollTrigger.refresh();
    initScrollAnimations();
  });
});

function initScrollAnimations() {
  const gsap = window.gsap;

  // 1. Reveal sections on scroll (fade and subtle slide up)
  const sections = document.querySelectorAll('.section, .media-with-content, .hero, .neeshika-all-coll-hero, .hero-story-scroll-stack');
  sections.forEach((section) => {
    if (section.dataset.framerSectionAnimated) return;
    section.dataset.framerSectionAnimated = 'true';

    // Set initial styles
    gsap.set(section, { opacity: 0, y: 30 });

    // Scroll animation
    gsap.to(section, {
      opacity: 1,
      y: 0,
      duration: 1.0,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 85%',
        toggleActions: 'play none none none',
        once: true
      }
    });
  });

  // 2. Parallax effect for media elements / images
  const parallaxImages = document.querySelectorAll('.media-block img, .hero img, .layered-slideshow img, .neeshika-all-coll-hero img');
  parallaxImages.forEach((img) => {
    if (img.dataset.framerParallaxAnimated) return;
    img.dataset.framerParallaxAnimated = 'true';

    const container = img.parentElement;
    if (container) {
      container.style.overflow = 'hidden';
      // Scale image up slightly initially to prevent transparent gaps
      gsap.set(img, { scale: 1.15 });

      gsap.to(img, {
        yPercent: -12,
        ease: 'none',
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }
  });

  // 3. Staggered reveal for grid elements (like product cards, collection links, blog posts)
  const gridContainers = document.querySelectorAll('.grid, .product-list__grid, .collection-list__grid, .blog-posts-list__grid');
  gridContainers.forEach((grid) => {
    if (grid.dataset.framerGridAnimated) return;
    grid.dataset.framerGridAnimated = 'true';

    const cards = grid.children;
    if (cards.length === 0) return;

    gsap.set(cards, { opacity: 0, y: 40 });

    gsap.to(cards, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power3.out',
      stagger: 0.08,
      scrollTrigger: {
        trigger: grid,
        start: 'top 85%',
        toggleActions: 'play none none none',
        once: true
      }
    });
  });

}
